import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, CalendarDays, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatDate, rupiah } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StatusBadge } from "@/components/StatusBadge";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

const GROUPS = {
  semua: null,
  aktif: ["menunggu_pembayaran", "dibayar", "dikerjakan", "menunggu_konfirmasi"],
  selesai: ["selesai"],
  lainnya: ["dibatalkan", "dikomplain"],
};
const LABELS = { semua: "Semua", aktif: "Aktif", selesai: "Selesai", lainnya: "Dibatalkan/Komplain" };

export default function Orders() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("semua");
  useEffect(() => {
    api.get("/orders").then((r) => setItems(r.data));
  }, []);
  const shown = (items || []).filter((o) => !GROUPS[tab] || GROUPS[tab].includes(o.status));
  const isCustomer = user.role === "pelanggan";

  return (
    <div className="container-page max-w-5xl py-10 lg:py-14" data-testid="orders-page">
      <p className="eyebrow">{isCustomer ? "Pelanggan" : "Penyedia"}</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Pesanan Saya</h1>
      <Tabs value={tab} onValueChange={setTab} className="mt-6">
        <TabsList className="rounded-full bg-stone-100 p-1">
          {Object.keys(GROUPS).map((k) => <TabsTrigger key={k} value={k} className="rounded-full px-4" data-testid={`orders-tab-${k}`}>{LABELS[k]}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="mt-6 space-y-4">
        {items === null ? <PageLoader /> : shown.length === 0 ? <EmptyState testId="orders-empty" title="Belum ada pesanan" /> : shown.map((o) => (
          <Link key={o.order_id} to={`/pesanan/${o.order_id}`} data-testid={`order-card-${o.order_id}`} className="card-soft card-lift flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:p-6">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-3">
                <h2 className="text-lg font-bold text-stone-900">{o.title}</h2>
                <StatusBadge status={o.status} testId={`order-status-${o.order_id}`} />
                <span className="chip">{o.source === "package" ? "Paket" : "Dari penawaran"}</span>
              </div>
              <p className="mt-1 text-sm text-stone-500">{isCustomer ? o.provider_name : o.customer_name}</p>
              <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-xs text-stone-500">
                <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {o.city_name}</span>
                <span className="flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {formatDate(o.scheduled_date)}</span>
              </div>
            </div>
            <p className="text-xl font-extrabold text-stone-900">{rupiah(o.price)}</p>
            <ArrowRight className="hidden h-5 w-5 text-stone-400 sm:block" />
          </Link>
        ))}
      </div>
    </div>
  );
}
